import { useMemo } from 'react';
import { getFirstSeriesPalette } from '../../../../utils/chartTheme';

export const useChartColorPalette = (data: string[][] | null | undefined, hasData: boolean) =>
  useMemo(() => {
    if (!data || data.length === 0 || !hasData) {
      return [];
    }

    return data.slice(1).map((item, index) => ({
      label: item[0],
      color: getFirstSeriesPalette()[index % getFirstSeriesPalette().length],
    }));
  }, [data, hasData]);
